import { isEqual } from 'lodash';
import { type Editor } from '@meitu/saas-editor-core';
import { type ITextLayerProps, type ITextMark as PersistedHighlight } from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';

export const useHighlight = (editor: Editor) => {
    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { textMark: highlight, textContents = [] } = layerData;

        return {
            highlight,
            textContents,
        };
    });

    const highlight = props?.highlight ?? null;
    const textContents = props?.textContents ?? [];

    const highlightsInTextContents = (() => {
        const ret: PersistedHighlight[] = [];
        textContents.forEach((item) => {
            const highlight = item.textMark;
            if (!highlight || ret.some((item) => isEqual(highlight, item))) return;
            ret.push(highlight);
        });
        return ret;
    })();

    const hasNoHighlight = highlight == null && highlightsInTextContents.length === 0;
    const hasMultipleHighlights = (() => {
        if (!highlight) return highlightsInTextContents.length > 1;
        if (highlightsInTextContents.length === 0) return false;
        if (highlightsInTextContents.length === 1) return !isEqual(highlight, highlightsInTextContents[0]);
        return true;
    })();

    return {
        highlightsInTextContents,
        highlight,
        hasNoHighlight,
        hasMultipleHighlights,
    };
};
